import RightArrowImg from "assets/icons/down-arrow.png";
import cx from "classnames";
import { Card, FlexBox } from "components";
import React, { useEffect, useState } from "react";
import ROUTE_PATH from "Routes/paths";
import { ChangeHistory } from "utils";
import { setGeneralDetails, useGeneralDetails } from "Slices";
import "./styles.scss";
import { DashboardHeaderProps } from "./types";
const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  className,
  title,
}) => {
  const [hasTimerClass, setHasTimerClass] = useState(false);

  //Slices
  const generalDetails = useGeneralDetails();

  const disableScrolling = () => {
    setTimeout(() => {
      setHasTimerClass(true);
    }, 500);
    var x = window.scrollX;
    var y = window.scrollY;
    window.onscroll = function () {
      window.scrollTo(x, y);
    };
  };

  const enableScrolling = () => {
    setHasTimerClass(false);
    window.onscroll = function () {};
  };

  useEffect(() => {
    generalDetails.isDashboardSideMenuOpened
      ? disableScrolling()
      : enableScrolling();
  }, [generalDetails.isDashboardSideMenuOpened]);

  return (
    <FlexBox
      justifyBetween
      alignCenter
      className={cx(className, "dashboard-header animated fadeInUp")}
    >
      <div>
        <p className="fs-32 font-heavy">{title}</p>
      </div>
      {window.screen.width > 968 ? (
        <div className="header-section">
          <FlexBox justifyBetween alignCenter>
            <p
              className="font-medium fs-16 curs-point mr-h-20"
              onClick={() => {
                ChangeHistory("back", ROUTE_PATH.SAMPLES.LANDING);
              }}
            >
              OTPless.com
            </p>
            <p
              className="font-medium fs-16 curs-point mr-h-20"
              onClick={() => {
                ChangeHistory("push", ROUTE_PATH.DOCS.HOME);
              }}
            >
              Docs
            </p>
          </FlexBox>
        </div>
      ) : (
        <div
          className={cx(
            generalDetails.isDashboardSideMenuOpened && "hamburger-menu-opened",
            hasTimerClass && "hamburger-menu-timer",
            "curs-point hamburger-menu"
          )}
          onClick={() => {
            setGeneralDetails({
              isDashboardSideMenuOpened:
                !generalDetails.isDashboardSideMenuOpened,
            });
          }}
        >
          <div />
          <div />
          <div />
        </div>
      )}
    </FlexBox>
  );
};
export default DashboardHeader;
